import React from 'react';
import { SxProp } from 'theme-ui';

import { LocationResiliencyToVulnerability } from 'models/BepiModels';

import { Typography } from 'components/_common/Typography';

type BepiVulnerabilityStatementProps = SxProp & {
  bepiLocationName: string;
  locationResiliency: number;
};

const BepiVulnerabilityStatement: React.FC<BepiVulnerabilityStatementProps> = ({
  bepiLocationName,
  locationResiliency,
  ...props
}) => {
  return (
    <Typography
      data-testid="location-vulnerability-score-description"
      variant="body2"
      color="stone90"
      {...props}
    >
      Relative to other global locations, {bepiLocationName} has&nbsp;
      <Typography variant="subtitle1" inline>
        {LocationResiliencyToVulnerability(locationResiliency)} vulnerability
      </Typography>
      &nbsp;to the potential spread and impact of infectious diseases.
    </Typography>
  );
};

export default BepiVulnerabilityStatement;
